<div class="modal-container">
  <div class="modal-header">
    <span class="ms-4 h5">Capture Photo</span>
    <button
      class="float-end"
      mat-icon-button
      mat-dialog-close
      aria-label="Close dialog"
      (click)="closeModal()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="modal-body text-center">
    <button
      mat-raised-button
      id="toggle"
      class="blue_button mb-3"
      (click)="toggleCamera()"
    >
      {{ toggleButtonText }}
    </button>

    <div id="app">
      <video #video id="video" autoplay playsinline></video>

      <div class="button-row">
        <button
          mat-stroked-button
          id="snap"
          color="secondary"
          (click)="startCamera()"
        >
          Retake
        </button>

        <button
          *ngIf="!isTakePhoto"
          mat-raised-button
          id="snap"
          class="blue_button ms-3"
          (click)="capture()"
        >
          Take photo
        </button>

        <button
          *ngIf="isTakePhoto"
          mat-raised-button
          id="snap"
          class="blue_button ms-3"
          (click)="sendImage()"
        >
          Use this photo
        </button>
      </div>

      <canvas
        #canvas
        id="canvas"
        height="480"
        style="display: none; width: 100%;"
      ></canvas>
    </div>
  </div>
</div>

<!--<div class="modal-container">-->
<!--  <div class="modal-header">-->
<!--    <span class="ms-4 h5">Capture Photo</span>-->
<!--    <button class="float-end" mat-icon-button mat-dialog-close aria-label="Close dialog" (click)="closeModal()">-->
<!--      <mat-icon>close</mat-icon>-->
<!--    </button>-->
<!--  </div>-->
<!--  <div class="row">-->
<!--    <div class="col-md-12" style="display: flex;-->
<!--        align-items: center;-->
<!--        justify-content: center;">-->
<!--      <button mat-raised-button id="toggle" class="blue_button mb-2" (click)="toggleCamera()">{{ toggleButtonText }}</button>-->
<!--    </div>-->
<!--  </div>-->
<!--  <div id="app">-->
<!--    <div>-->
<!--      <video #video id="video" autoplay playsinline></video>-->
<!--    </div>-->
<!--    <div class="button-row">-->
<!--      <button mat-stroked-button id="snap" class="" color="secondary" (click)="startCamera()">Retake</button>-->
<!--      <button *ngIf="!isTakePhoto" mat-raised-button id="snap" class="blue_button ms-3" (click)="capture()">Take photo</button>-->
<!--      <button *ngIf="isTakePhoto" mat-raised-button id="snap" class="blue_button ms-3" (click)="sendImage()">Use this photo</button>-->
<!--    </div>-->
<!--    <canvas #canvas id="canvas" height="480" style="display: none; width: 100%;"></canvas>-->

<!--  </div>-->
<!--</div>-->
<!--&lt;!&ndash; <div class="modal-container" style="height: 100vh !important;">-->
<!--    <div class="modal-header">-->
<!--        <h3>Capture Photo</h3>-->
<!--        <button mat-icon-button (click)="closeModal()" class="mb-2">-->
<!--            <mat-icon>close</mat-icon></button>-->
<!--        </div> &ndash;&gt;-->
<!--<div mat-dialog-title class="p-0">-->
<!--  <span class="col-12 ms-4">Capture Photo</span>-->
<!--  <button class="float-end mt-2 me-2" mat-icon-button mat-dialog-close aria-label="Close dialog" [mat-dialog-close] tabindex="-1">-->
<!--    <mat-icon>close</mat-icon>-->
<!--  </button>-->
<!--</div>-->

<!--<mat-dialog-content class="mt-4">-->
<!--    <div class="row">-->
<!--        <div class="col-md-12" style="display: flex;-->
<!--        align-items: center;-->
<!--        justify-content: center;">-->
<!--            <button mat-raised-button id="toggle" class="blue_button mb-2" (click)="toggleCamera()">{{ toggleButtonText }}</button>-->
<!--        </div>-->
<!--    </div>-->
<!--    <div id="app">-->
<!--        <div>-->
<!--            <video #video id="video" autoplay playsinline></video>-->
<!--        </div>-->
<!--        <div class="button-row">-->
<!--            <button mat-stroked-button id="snap" class="" color="secondary" (click)="startCamera()">Retake</button>-->
<!--            <button *ngIf="!isTakePhoto" mat-raised-button id="snap" class="blue_button ms-3" (click)="capture()">Take photo</button>-->
<!--            <button *ngIf="isTakePhoto" mat-raised-button id="snap" class="blue_button ms-3" (click)="sendImage()">Use this photo</button>-->
<!--        </div>-->
<!--        <canvas #canvas id="canvas" height="480" style="display: none; width: 100%;"></canvas>-->
<!--    -->
<!--    </div>-->
<!--</mat-dialog-content>-->
<!--&lt;!&ndash; </div> &ndash;&gt;-->
<!--        -->
<!-- -->
